// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ServerMessaeSide;
(function (ServerMessaeSide) {
    ServerMessaeSide[ServerMessaeSide["Input"] = 0] = "Input";
    ServerMessaeSide[ServerMessaeSide["Output"] = 1] = "Output";
})(ServerMessaeSide || (ServerMessaeSide = {}));
